import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { ButtonVariant, buttonClass } from '../../utils/styles';
type ButtonLinkProps = {
  to: string;
  variant?: ButtonVariant;
  className?: string;
  children: ReactNode;
  /** Use a native anchor for same-page section links */
  inPage?: boolean;
};
export function ButtonLink({
  to,
  variant = 'gold',
  className = '',
  children,
  inPage = false
}: ButtonLinkProps) {
  if (inPage) {
    return <a href={to} className={buttonClass(variant, className)} data-id="element-297" data-mp="1rtwg0lat0nyv">
        {children}
      </a>;
  }
  return <Link to={to} className={buttonClass(variant, className)} data-id="element-298" data-mp="1iqvb2nxod2ws">
      {children}
    </Link>;
}